<div class="container-fluid" *ngIf="loading">
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Chargement...</span>
    </div>
    <p class="mt-2 text-muted">Chargement des documents...</p>
  </div>
</div>

<div class="container-fluid" *ngIf="!loading && promotion">
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <button (click)="goBack()" type="button" class="btn btn-secondary mr-3">
            <i class="fa fa-arrow-alt-circle-left"></i> Retour
          </button>
          <div>
            <h4 class="mb-0">
              <i class="fas fa-file-pdf text-danger mr-2"></i>
              Documents - {{ promotion?.libelle }}
            </h4>
            <small class="text-muted">{{ promotion?.code }} - {{ promotion?.ville }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Documents Grid -->
  <div class="row mb-4">
    <div class="col-12">
      <span class="badge badge-primary mb-3 f-14">
        <i class="fas fa-file-alt mr-1"></i> Documents imprimables
      </span>
    </div>
    <div class="col-lg-4 col-md-6 mb-3" *ngFor="let doc of documents">
      <div class="card document-card h-100">
        <div class="card-body d-flex flex-column">
          <div class="text-center mb-3">
            <div class="document-icon">
              <i [class]="doc.icon + ' fa-2x'"></i>
            </div>
          </div>
          <h6 class="card-title text-center">{{ doc.title }}</h6>
          <p class="card-text text-muted text-center flex-grow-1">{{ doc.description }}</p>
          <div class="text-center mt-2">
            <button (click)="previewDocument(doc)" type="button" class="btn btn-outline-primary btn-sm">
              <i class="fas fa-eye mr-1"></i> Apercu
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Configuration du rapport PDF -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">
            <i class="fas fa-cogs mr-2"></i>
            Configuration du Rapport PDF
          </h5>
          <p class="card-text text-muted mb-0 mt-1">
            Personnalisez l'affichage des sections sur la fiche de souscription et l'echeancier PDF.
          </p>
        </div>

        <div class="card-body" [formGroup]="form">
          <!-- Section En-tete -->
          <div formGroupName="header">
            <h6 class="mb-3"><i class="fas fa-heading mr-1"></i> En-tete de la fiche</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowTotalCharges" formControlName="showTotalCharges">
                  <label class="custom-control-label" for="docShowTotalCharges">Afficher "Total charges"</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowMontantTotal" formControlName="showMontantTotal">
                  <label class="custom-control-label" for="docShowMontantTotal">Afficher "Montant total"</label>
                </div>
              </div>
            </div>
          </div>

          <hr>

          <!-- Section Tableau -->
          <div formGroupName="tableau">
            <h6 class="mb-3"><i class="fas fa-table mr-1"></i> Tableau de la fiche</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowChargesMensuelles" formControlName="showChargesMensuelles">
                  <label class="custom-control-label" for="docShowChargesMensuelles">Afficher ligne "Charges mensuelles"</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowTotalTVA" formControlName="showTotalTVA">
                  <label class="custom-control-label" for="docShowTotalTVA">Afficher "TOTAL TVA"</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowTotalChargesTab" formControlName="showTotalCharges">
                  <label class="custom-control-label" for="docShowTotalChargesTab">Afficher "TOTAL CHARGES"</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowTotalTTC" formControlName="showTotalTTC">
                  <label class="custom-control-label" for="docShowTotalTTC">Afficher "TOTAL TTC"</label>
                </div>
              </div>
            </div>
          </div>

          <hr>

          <!-- Section Echeancier -->
          <div formGroupName="echeancier">
            <h6 class="mb-3"><i class="fas fa-calendar-check mr-1"></i> Echeancier</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="docShowTotal" formControlName="showTotal">
                  <label class="custom-control-label" for="docShowTotal">Afficher le TOTAL de l'echeancier</label>
                </div>
              </div>
            </div>
          </div>

          <hr>

          <!-- Section Mentions -->
          <div formGroupName="footer">
            <h6 class="mb-3"><i class="fas fa-comment-alt mr-1"></i> Mentions en pied de page</h6>
            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="newMention" [ngModelOptions]="{standalone: true}"
                placeholder="Ajouter une mention..." (keyup.enter)="addMention()">
              <div class="input-group-append">
                <button type="button" class="btn btn-primary" (click)="addMention()" [disabled]="!newMention?.trim()">
                  <i class="fas fa-plus"></i> Ajouter
                </button>
              </div>
            </div>
            <div *ngIf="mentions.length > 0">
              <div *ngFor="let mention of mentions; let i = index" class="d-flex align-items-center mb-2 p-2 bg-light rounded">
                <i class="fas fa-quote-left text-muted mr-2"></i>
                <span class="flex-grow-1">{{ mention }}</span>
                <button type="button" class="btn btn-sm btn-outline-danger ml-2" (click)="removeMention(i)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div *ngIf="mentions.length === 0" class="text-muted">
              <i class="fas fa-info-circle mr-1"></i> Aucune mention configuree.
            </div>
          </div>
        </div>

        <div class="card-footer text-right">
          <button type="button" class="btn btn-success" (click)="saveConfig()" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
            <i *ngIf="!saving" class="fas fa-save mr-1"></i>
            {{ saving ? 'Enregistrement...' : 'Enregistrer la configuration' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
